import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Card, Button, message } from 'antd';
import { DownloadOutlined, EyeOutlined } from '@ant-design/icons';
import axios from 'axios';

const PhotoGallery = ({ photos, planTitle }) => {
  if (!photos || photos.length === 0) return null;

  const getFileExtension = contentType => {
    const extensions = {
      'image/jpeg': 'jpg',
      'image/jpg': 'jpg',
      'image/png': 'png',
      'image/gif': 'gif',
      'image/webp': 'webp',
      'image/svg+xml': 'svg',
      'image/bmp': 'bmp',
      'image/tiff': 'tiff'
    };
    return extensions[contentType] || 'jpg';
  };

  const handleOpenImage = url => {
    window.open(url, '_blank');
  };

  const handleDownload = async (url, index) => {
    try {
      const response = await axios.post(
        '/api/download/image',
        { url },
        {
          responseType: 'blob',
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );

      const contentType = response.headers['content-type'];
      const extension = getFileExtension(contentType);
      const blob = new Blob([response.data], { type: contentType });
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = `${planTitle}-${index + 1}.${extension}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error('Download error:', error);
      message.error(`Error downloading photo: ${error.message}`);
    }
  };

  return (
    <Card size="small" title="Photos">
      <Row gutter={[16, 16]}>
        {photos.map((photo, index) => {
          const photoUrl = photo.url || photo.original || photo;
          return (
            <Col xs={24} sm={12} lg={8} key={index}>
              <Card
                hoverable
                cover={
                  <img
                    src={photoUrl}
                    alt={`render ${index + 1}`}
                    style={{ height: '350px', objectFit: 'cover' }}
                  />
                }
                bodyStyle={{ display: 'none' }}
                actions={[
                  <Button
                    key="view"
                    type="link"
                    onClick={() => handleOpenImage(photoUrl)}
                    icon={<EyeOutlined />}
                  >
                    View
                  </Button>,
                  <Button
                    key="download"
                    type="link"
                    onClick={() => handleDownload(photoUrl, index)}
                    icon={<DownloadOutlined />}
                  >
                    Download
                  </Button>
                ]}
              />
            </Col>
          );
        })}
      </Row>
    </Card>
  );
};

PhotoGallery.propTypes = {
  photos: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        url: PropTypes.string,
        original: PropTypes.string
      })
    ])
  ),
  planTitle: PropTypes.string
};

export default PhotoGallery;
